module.exports = __webpack_public_path__ + "img/shield.5db00fb5.svg";